// extracted by mini-css-extract-plugin
module.exports = {"markdown":"StyledText_markdown__rg00m"};